import React from "react";

// v2.7.65+E232 · Customer Type classification. Values ARE the stored labels so
// they render consistently everywhere (dispatch form, Ride Coordinator, Future
// Fares, Completed Rides, driver app). Keep this list in sync with the backend.
export const CUSTOMER_TYPES = [
  "Regular Customer",
  "Business Customer",
  "Charge Account",
  "CCVAP Recipient",
  "Law Enforcement Pickup",
];

const STYLES = {
  "Regular Customer":       { c: "border-zinc-500/50 text-zinc-300 bg-zinc-500/10",     s: "Regular" },
  "Business Customer":      { c: "border-sky-400/50 text-sky-300 bg-sky-500/10",        s: "Business" },
  "Charge Account":         { c: "border-amber-400/50 text-amber-300 bg-amber-500/10",  s: "Charge Acct" },
  "CCVAP Recipient":        { c: "border-violet-400/50 text-violet-300 bg-violet-500/10", s: "CCVAP" },
  "Law Enforcement Pickup": { c: "border-red-400/60 text-red-300 bg-red-500/10",        s: "Law Enforcement" },
};

export function CustomerTypeBadge({ type, short = false, className = "", testid }) {
  const t = (type || "").trim();
  if (!t) return null;
  const st = STYLES[t] || { c: "border-zinc-500/50 text-zinc-300 bg-zinc-500/10", s: t };
  return (
    <span
      data-testid={testid}
      title={t}
      className={`inline-flex items-center text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded border ${st.c} ${className}`}
    >
      {short ? st.s : t}
    </span>
  );
}

export default CustomerTypeBadge;
